import React from 'react';
import { CheckboxInput, useFormContextRequired } from 'ui-builder';
import { useEffect } from 'react';
import { PlanTask } from 'nekst-api';
import styles from './RoadmapDescription.module.scss';

export function CopyRoadmapDescriptionCheckbox() {
  const formContext = useFormContextRequired<
    PlanTask & { copyRoadmapDescription: boolean | undefined }
  >();

  useEffect(() => {
    // Backend interprets undefined roadmapDescription as "copy from task description"
    if (formContext.data?.copyRoadmapDescription) {
      formContext.onChangeCallback({
        roadmapDescription: undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formContext.data?.copyRoadmapDescription]);

  return (
    <CheckboxInput
      source="copyRoadmapDescription"
      label="Use Task Description in Portal"
      className={`${styles.useTaskDescription} ${styles.noMargin}`}
      defaultValue={true}
      isDisabled={(data) => !data.isIncludedToRoadmap}
    />
  );
}
